<template>
  <div v-if="school_valid" class="experiment ma-0">
    <v-tabs
      class="elevation-2"
      background-color="#f5f5f5"
      color="red"
      slider-size="4"
    >
      <v-tab disabled>
      </v-tab>
      <v-tab :href="`#tab-group-experiment-create`">
        Create
      </v-tab>
      <v-tab :href="`#tab-group-experiment-history`">
        History
      </v-tab>
      <v-tab-item :value="'tab-group-experiment-create'">
        <CreateGroupExperiment />
      </v-tab-item>
      <v-tab-item :value="'tab-group-experiment-history'">
        <GroupExperimentHistory />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

import CreateGroupExperiment from "@/components/management/group_experiment/CreateGroupExperiment.vue";
import GroupExperimentHistory from "@/components/management/group_experiment/GroupExperimentHistory.vue";

export default {
  name: "experiment",
  components: {
    CreateGroupExperiment,
    GroupExperimentHistory,
  },
  mixins: [],
  data: function () {
    return {
      menu: false,
      form: {
        start_from: "09:00",
        end_at: "18:00",
        duration: "55",
        prepare: "5",
        school: "",
        dates: [],
        experiment: "",
        equipment_id: "",
      },
      school_id: "",
      experiment: "",
      equipment_id: "",
      school_valid: false,
      role: null,
      drawer: true,
      mini: true,
      slot_view: false,
      breadcrumbs: "",
      booking_breadcrumbs: "",
      selected_slot: null,
      api: {
        book_slots: [],
        bookings: [],
      },
    };
  },
  mounted: function () {
    var self = this;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.params.experiment;
    self.equipment_id = self.$route.params.equipment_id;
    self.form.school = self.school_id;
    self.form.experiment = self.experiment;
    self.form.equipment_id = self.equipment_id;
    self.booking_breadcrumbs = [
            { text: self.school_id },
          ];
    self.getSchoolFromSchoolList();
  },
  methods: {    
    getSchoolFromSchoolList() {
      var self = this;
      apiManagement.getSchoolFromSchoolList(self.school_id).then((response) => {
        if (response.status == "success") {
          self.school_valid = true;
        } else {
          self.school_valid = false;
          alert(response.error);
        }
      });
    },
    back() {
      var self = this;
      self.$router.push("/school/experiment_list/" + self.school_id);
    },
  },
  destroyed() {
    clearInterval(this.kick_inte);
    self.$cookies.remove("experiment");
    self.$cookies.remove("equipment_id");
    console.log("destroyed");
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>